import { EnvelopeIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Client } from "../../../models/Client";
import { ConfirmationModal } from "../../ConfirmationModal";
import { useTranslation } from "react-i18next";

interface Props {
    info: {
        show: boolean;
        client?: Client;
    };
    onClose: () => void;
    sentMail: (client: Client) => void
}

export const SentMailConfirmationModal: React.FC<Props> = ({
    info,
    onClose,
    sentMail
}) => {

    const { t } = useTranslation();

    const onSentMail = () => {
        sentMail(info.client!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("SEND_MAIL")}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("SEND"), icon: <EnvelopeIcon />, onClick: onSentMail }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('SEND_MAIL_MESSAGE')}
                </label>
            </div>
        </ConfirmationModal>
    )
}